export enum Reputation {
    LegionHighmountainTribe = 1828,
    LegionTheNightfallen = 1859,
    LegionDreamweavers = 1883,
    LegionTheWardens = 1894,
    LegionCourtOfFarondis = 1900,
    LegionValarjar = 1948,
    LegionConjurerMargoss = 1975,
    LegionTalonsVengeance = 2018,
    LegionArmiesOfLegionfall = 2045,
    LegionIlyssiaOfTheWaters = 2097,
    LegionKeeperRaynae = 2098,
    LegionAkuleRiverhorn = 2099,
    LegionCorbyn = 2100,
    LegionShaleth = 2101,
    LegionImpus = 2102,
    LegionChromie = 2135,
    LegionArmyOfTheLight = 2165,
    LegionArgussianReach = 2170,

    BfaZandalariEmpire = 2103,
    BfaTalanjisExpedition = 2156,
    BfaTheHonorbound = 2157,
    BfaVoldunai = 2158,
    Bfa7thLegion = 2159,
    BfaProudmooreAdmiralty = 2160,
    BfaOrderOfEmbers = 2161,
    BfaStormsWake = 2162,
    BfaTortollanSeekers = 2163,
    BfAChampionsOfAzeroth = 2164,
    BfaTheUnshackled = 2373,
    BfaHunterAkana = 2375,
    BfaFarseerOri = 2376,
    BfaBladesmanInowari = 2377,
    BfaPoenGillbrack = 2388,
    BfaNeriSharpfin = 2389,
    BfaVimBrineheart = 2390,
    BfaRustboltResistance = 2391,
    BfaHoneybackHive = 2395,
    BfaHoneybackDrone = 2396,
    BfaHoneybackHivemother = 2397,
    BfaHoneybackHarvester = 2398,
    BfaWavebladeAnkoan = 2400,
    BfaRajani = 2415,
    BfaUldumAccord = 2417,

    SlTheAscended = 2407,
    SlTheUndyingArmy = 2410,
    SlCourtOfHarvesters = 2413,
    SlVenari = 2432,
    SlTheAvowed = 2439,
    SlTheEmberCourt = 2445,
    SlStitchmasters = 2462,
    SlMarasmius = 2463,
    SlCourtOfNight = 2464,
    SlTheWildHunt = 2465,
    SlDeathsAdvance = 2470,
    SlTheArchivistsCodex = 2472,
    SlTheEnlightened = 2478,
}
